import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordian';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { ArrowLeft } from 'lucide-react';
import React from 'react';

type HowItWorksProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const HowItWorks: React.FC<HowItWorksProps> = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const acccordianHeadingClassName = 'text-sm text-[#FFFFFF]';
  const acccordianContentClassName = 'text-xs text-[#FFFFFF] mt-2';

  return (
    <div>
      <Dialog open={open}>
        <DialogContent onClose={handleClose} className='p-8 bg-[#151525]'>
          <div id='heading'>
            <span className='flex flex-row items-center text-2xl font-bold'>
              <ArrowLeft className='mr-2 cursor-pointer' onClick={handleClose} /> How it Works
            </span>
            <Separator className='my-2 opacity-45' />
          </div>
          <div>
            <h3>
              <div>Your Fitness, Your Rules.</div>
              <div>1:1 Training, Anywhere, 24x7</div>
            </h3>
            <span className='text-sm text-[#C5C8D0] mt-2'>
              Your Trainer, Your Pace, Your Place, We have designed FitStatic with the goal of
              making fitness training accessible for everyone. Sign up is easy and simple through
              our website or the mobile App. Create your profile and request a free session.{' '}
            </span>
          </div>
          <div>
            <h3>FAQ</h3>
            <Accordion type='single' collapsible className='w-full'>
              <AccordionItem value='item-1'>
                <AccordionTrigger className={acccordianHeadingClassName}>
                  How do I sign up for a training session?
                </AccordionTrigger>
                <AccordionContent className={acccordianContentClassName}>
                  We have designed FitStatic with the goal of making fitness training accessible for
                  everyone. Sign up is easy and simple through our website or the mobile App. Create
                  your profile and request a free session. It’s that simple. One of our team members
                  will contact you by text message for scheduling your first session. You can
                  schedule future sessions conveniently from our mobile App.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='item-2'>
                <AccordionTrigger className={acccordianHeadingClassName}>
                  Can I try FitStatic without paying for a session?
                </AccordionTrigger>
                <AccordionContent className={acccordianContentClassName}>
                  Yes. We offer one free session to all clients who want to try out FitStatic.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='item-3'>
                <AccordionTrigger className={acccordianHeadingClassName}>
                  How do I buy training sessions?
                </AccordionTrigger>
                <AccordionContent className={acccordianContentClassName}>
                  You can buy training sessions through our website or Mobile App. Click on “Buy
                  Training Sessions” and we will take care of the rest.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='item-4'>
                <AccordionTrigger className={acccordianHeadingClassName}>
                  Can I specify the type of exercise I would like to schedule?
                </AccordionTrigger>
                <AccordionContent className={acccordianContentClassName}>
                  Yes. We offer multiple workout styles and fitness programs. You can specify the
                  type of training that aligns best with your fitness goals
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='item-5'>
                <AccordionTrigger className={acccordianHeadingClassName}>
                  Do I need a gym membership to use FitStatic?
                </AccordionTrigger>
                <AccordionContent className={acccordianContentClassName}>
                  No. FitStatic is a virtual one-on-one fitness training program that does not
                  require a gym membership.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='item-6'>
                <AccordionTrigger className={acccordianHeadingClassName}>
                  Can I use FitStatic while I workout at my gym?
                </AccordionTrigger>
                <AccordionContent className={acccordianContentClassName}>
                  Yes. You can train with FitStatic anywhere at any time. Please check with your gym
                  if they allow the use of virtual fitness trainers while using the facility.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HowItWorks;
